import { render, staticRenderFns } from "./dragverify.vue?vue&type=template&id=c61bfd2a&"
import script from "./dragverify.vue?vue&type=script&lang=js&"
export * from "./dragverify.vue?vue&type=script&lang=js&"
import style0 from "./dragverify.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports